<template lang="html">
    <div class="about-page">
        <Banner :imageCoverURL="baseUrlStorage+data.background" :title="data.title" />
        <section class="misionvision">
            <div class="content">
                <div class="container">
                    <p
                        class="general"
                    >{{data.description}}</p>
                    <div class="about">
                        <div class="about-item">
                            <h6 class="title">Misión</h6>
                            <p
                                class="description"
                            >{{data.mision}}</p>
                        </div>
                        <div class="about-item">
                            <h6 class="title">Visión</h6>
                            <p
                                class="description"
                            >{{data.vision}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cortina"></div>
        </section>
        <section class="members">
            <div class="container">
                <h4 class="title" data-aos="fade-right" data-aos-duration="1000" >Integrantes</h4>
                <div class="list">
                    <CardMemberList :data="data.members"/>
                </div>
                <div class="figure">
                    <svg
                        width="6260"
                        height="3122"
                        viewBox="0 0 6260 3122"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6241.63 1141.44C6267.29 906.647 6280.06 651.723 6167.77 422.28C6071.92 226.526 5667.28 213.816 5340.75 177.937C5208.55 163.403 5075.89 148.869 4942.43 138.105C4893.87 134.152 4843.48 130.443 4796.08 139.929C4746.6 149.842 4743.73 189.674 4784.92 205.181C4819.89 218.377 4868.79 223.181 4909.64 228.107C4968.09 236.681 5024.46 249.209 5079.11 263.135C5203.72 294.939 5321.08 334.467 5417.15 387.799C5592.95 477.922 5701.91 584.283 5744.13 707.001C5786.36 829.659 5791.54 1037.39 5770.94 1225.85C5755.52 1366.51 5669.81 1617.42 5536.46 1769.93C5403.11 1922.45 5211.77 2060.43 4962.33 2184C4712.89 2307.51 4406.39 2406.7 4042.93 2481.56C3679.47 2556.35 3262.62 2586.52 2792.28 2571.98C2406.5 2560.06 2038.09 2522.54 1687.06 2459.42C1336.02 2396.36 1034.23 2283.25 781.573 2120.21C633.152 2022.49 523.505 1909.74 452.631 1781.91C240.469 1399.35 452.401 538.248 978.893 313.913C1090.38 263.743 1212.34 227.316 1344.77 204.573C1477.2 181.829 1604.33 170.944 1726.18 171.917C1776.8 173.498 1887.94 177.207 1903.71 140.902C1925.8 89.6379 1792.22 83.9216 1728.48 78.8134C1449.93 48.7723 860.041 35.8801 580.687 7.90659C479.784 -2.1882 366.109 -16.0533 338.036 65.3739C315.945 129.348 293.394 195.208 256.922 261.857C109.651 531.133 41.6536 813.179 11.164 1092.49C-33.4774 1500.78 46.4858 2012.94 447.453 2369.54C874.078 2748.95 1587.76 3002.53 2399.71 3087.06C3209.35 3171.41 4107.24 3105.67 4794.93 2853.54C5451.32 2612.91 5869.43 2236.24 6064.79 1831.11C6157.18 1639.67 6220 1338.66 6241.63 1141.44Z"
                            fill="#33647E"
                            fill-opacity="0.1"
                        />
                    </svg>
                </div>
            </div>
        </section>
        <section v-if="data.directors.length > 0" class="consejo">
            <div class="container">
                <h5 class="title" data-aos="fade-right" data-aos-duration="1000" >Consejo Directivo ssss {{ data.directors.length }}</h5>
                <ListCardPersonInfo :data="data.directors"/>
            </div>
            <div class="figure-01">
                <svg
                    width="703"
                    height="918"
                    viewBox="0 0 703 918"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.05"
                        d="M622.873 716.273C623.605 709.833 620.185 702.104 614.164 702.104C603.843 702.104 601.371 716.273 601.937 718.849C597.061 776.811 578.629 810.3 551.634 828.332C524.64 846.365 505.151 843.789 478.489 843.789C447.526 843.789 412.683 847.653 390.125 811.588C381.27 798.707 373.587 775.523 375.972 739.458C378.356 703.392 382.9 663.463 385.685 638.991L398.292 528.219C400.051 512.763 401.243 494.73 406.99 489.578C412.737 484.426 424.778 484.426 437.679 484.426C460.901 484.426 514.519 481.85 532.288 484.426C548.336 487.002 556.624 497.306 562.752 511.475C568.021 525.643 567.268 539.812 566.389 547.54C565.949 551.404 564.336 565.572 563.603 572.013C563.437 581.029 569.878 584.893 574.179 584.893C579.339 584.893 585.379 577.165 585.545 568.148C586.298 553.98 585.731 551.404 586.903 541.1C590.881 498.594 595.259 467.681 605.696 421.312C609.615 401.991 617.542 385.247 609.82 377.519C608.247 376.231 601.239 369.791 594.613 382.671C587.126 395.551 578.066 407.144 562.565 414.872C548.071 421.312 523.276 420.024 512.095 420.024C508.654 420.024 446.729 420.024 423.507 420.024C421.786 420.024 417.339 421.312 414.632 414.872C411.065 408.432 412.804 400.703 413.391 395.551L445.64 112.183C446.666 103.166 447.106 99.3024 451.279 92.8622C452.286 91.5742 456.879 88.998 460.32 88.998C471.501 88.998 494.869 87.71 518.951 87.71C554.215 87.71 594.638 87.71 622.161 87.71C640.222 87.71 647.797 96.7263 652.791 105.743C662.067 122.487 661.735 140.52 660.709 149.536C659.243 162.416 656.751 184.313 655.852 199.769C655.246 212.65 660.973 215.226 664.414 215.226C671.294 215.226 675.614 207.498 676.201 202.345C677.08 194.617 676.806 189.465 678.859 171.433C681.077 144.384 685.309 114.759 686.335 105.743C690.566 76.1177 696.665 45.2047 702.47 16.8679C704.356 7.85162 699.361 -1.16464 693.194 0.123395C681.867 1.41143 666.659 6.56357 660.492 7.85161C615.602 16.8679 579.752 22.02 534.882 23.3081C489.151 24.5961 441.847 24.5961 395.256 25.8842C348.812 25.8842 301.654 24.5961 255.356 23.3081C210.779 22.02 176.102 16.8679 133.264 7.85161C127.39 6.56357 112.349 2.69947 102.321 0.123395C96.4468 -1.16464 89.4002 7.85162 89.2341 16.8679C89.4495 45.2047 87.6515 76.1177 85.1401 105.743C84.114 114.759 81.6025 144.384 77.6641 171.433C75.7585 188.177 74.1655 194.617 73.2859 202.345C72.6996 207.498 76.1205 215.226 82.141 215.226C85.5814 215.226 92.9017 211.362 94.221 199.769C96.8401 184.313 98.472 162.416 100.798 149.536C101.824 140.52 105.596 122.487 118.683 105.743C125.73 96.7263 135.357 87.71 153.418 87.71C180.941 87.71 220.504 87.71 256.628 87.71C280.71 87.71 304.792 87.71 315.826 88.998C319.267 88.998 322.414 91.5742 323.987 92.8622C326.841 98.0143 326.255 103.166 325.229 112.183L292.98 395.551C292.393 400.703 292.227 409.72 287.341 414.872C283.167 421.312 279.013 420.024 277.293 420.024C254.071 420.024 191.286 420.024 187.845 420.024C176.664 420.024 152.289 422.6 138.547 414.872C124.805 407.144 118.237 396.839 113.829 382.671C109.988 371.079 100.801 376.231 99.7942 377.519C90.1673 386.535 94.2823 403.28 93.9502 421.312C93.8335 467.681 91.3221 497.306 85.478 541.1C84.3053 551.404 83.1521 553.98 80.6795 568.148C78.7933 577.165 83.0743 584.893 88.2347 584.893C92.5351 584.893 99.8555 581.029 101.742 572.013C102.475 565.572 104.087 551.404 104.527 547.54C105.406 539.812 107.732 526.931 116.372 511.475C125.012 496.018 136.505 485.714 152.993 484.426C171.348 481.85 224.38 484.426 248.462 484.426C261.363 484.426 273.404 484.426 277.978 489.578C282.552 494.73 279.64 512.763 277.881 528.219L265.275 638.991C262.343 664.751 257.945 703.392 252.121 739.458C246.443 774.235 233.483 797.419 221.55 811.588C190.783 847.653 155.959 843.789 124.997 843.789C99.1942 843.789 78.2592 846.365 55.3692 828.332C33.1927 811.588 21.5225 778.099 29.9857 718.849C30.4255 714.985 31.0312 702.104 21.5704 702.104C15.5498 702.104 10.3699 709.833 9.63699 716.273C7.16445 730.441 2.78625 761.354 0.802813 809.012C0.216462 814.164 0.138684 845.077 1.94708 866.973C3.48175 883.718 6.90265 891.446 12.6106 901.75C21.319 915.919 34.9337 917.207 40.9542 917.207C68.4767 917.207 144.164 917.207 190.608 917.207C224.151 917.207 292.957 917.207 292.957 917.207C292.957 917.207 360.903 917.207 394.446 917.207C440.89 917.207 516.577 917.207 544.1 917.207C550.12 917.207 564.028 915.919 575.962 901.75C584.875 891.446 589.195 883.718 594.541 866.973C601.333 845.077 607.431 814.164 608.878 809.012C619.462 761.354 621.26 730.441 622.873 716.273Z"
                        fill="#335B6F"
                    />
                </svg>
            </div>
            <div class="figure-02">
                <svg
                    width="704"
                    height="918"
                    viewBox="0 0 704 918"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.05"
                        d="M622.845 200.948C623.582 207.388 620.165 215.116 614.144 215.116C603.823 215.116 601.343 200.948 601.909 198.372C597.003 140.414 578.554 106.927 551.55 88.8955C524.546 70.864 505.059 73.44 478.397 73.44C447.434 73.44 412.589 69.5761 390.049 105.639C381.201 118.519 373.53 141.702 375.933 177.765C378.335 213.828 382.9 253.755 385.697 278.226L398.36 388.991C400.127 404.447 401.328 422.478 407.078 427.63C412.827 432.782 424.868 432.782 437.769 432.782C460.991 432.782 514.611 435.358 532.378 432.782C548.425 430.206 556.708 419.902 562.829 405.735C568.09 391.567 567.33 377.399 566.447 369.672C566.005 365.808 564.386 351.64 563.649 345.2C563.479 336.185 569.918 332.321 574.218 332.321C579.378 332.321 585.422 340.048 585.593 349.064C586.353 363.232 585.787 365.808 586.965 376.111C590.964 418.614 595.358 449.525 605.819 495.892C609.747 515.212 617.682 531.955 609.965 539.683C608.392 540.971 601.387 547.411 594.755 534.531C587.262 521.651 578.196 510.06 562.691 502.332C548.193 495.892 523.398 497.18 512.217 497.18C508.777 497.18 446.852 497.18 423.629 497.18C421.909 497.18 417.462 495.892 414.758 502.332C411.193 508.772 412.937 516.499 413.526 521.651L445.919 805.003C446.949 814.019 447.391 817.883 451.568 824.323C452.575 825.611 457.17 828.187 460.61 828.187C471.791 828.187 495.16 829.475 519.243 829.475C554.506 829.475 594.929 829.475 622.452 829.475C640.514 829.475 648.084 820.459 653.074 811.443C662.34 794.7 661.999 776.668 660.969 767.653C659.496 754.773 656.993 732.877 656.086 717.422C655.474 704.542 661.2 701.966 664.64 701.966C671.521 701.966 675.845 709.694 676.434 714.846C677.317 722.574 677.046 727.726 679.107 745.757C681.339 772.804 685.586 802.427 686.617 811.443C690.863 841.066 696.977 871.978 702.797 900.313C704.688 909.329 699.698 918.344 693.53 917.056C682.202 915.768 666.991 910.616 660.824 909.329C615.929 900.313 580.077 895.161 535.205 893.873C489.474 892.585 442.17 892.585 395.578 891.297C349.134 891.297 301.977 892.585 255.68 893.873C211.103 895.161 176.429 900.313 133.596 909.329C127.723 910.616 112.683 914.48 102.656 917.056C96.7831 918.344 89.7319 909.329 89.5613 900.313C89.7623 871.978 87.9487 841.066 85.4222 811.443C84.3915 802.427 81.8651 772.804 77.913 745.757C75.9988 729.014 74.4026 722.574 73.5191 714.846C72.9302 709.694 76.3472 701.966 82.3677 701.966C85.808 701.966 93.1303 705.83 94.4555 717.422C97.0825 732.877 98.7254 754.773 101.058 767.653C102.089 776.668 105.87 794.7 118.965 811.443C126.016 820.459 135.648 829.475 153.71 829.475C181.232 829.475 220.796 829.475 256.919 829.475C281.001 829.475 305.083 829.475 316.117 828.187C319.557 828.187 322.703 825.611 324.276 824.323C327.127 819.171 326.538 814.019 325.508 805.003L293.115 521.651C292.526 516.499 292.355 507.484 287.466 502.332C283.29 495.892 279.136 497.18 277.416 497.18C254.194 497.18 191.408 497.18 187.968 497.18C176.787 497.18 152.41 494.604 138.673 502.332C124.935 510.06 118.372 520.363 113.971 534.531C110.136 546.123 100.946 540.971 99.9387 539.683C90.3072 530.667 94.4136 513.924 94.0724 495.892C93.9323 449.525 91.4058 419.902 85.5396 376.111C84.3616 365.808 83.2071 363.232 80.7274 349.064C78.8366 340.048 83.1136 332.321 88.2741 332.321C92.5745 332.321 99.8968 336.185 101.788 345.2C102.524 351.64 104.143 365.808 104.585 369.672C105.469 377.399 107.801 390.279 116.449 405.735C125.096 421.19 136.595 431.494 153.084 432.782C171.44 435.358 224.47 432.782 248.552 432.782C261.453 432.782 273.494 432.782 278.066 427.63C282.638 422.478 279.716 404.447 277.949 388.991L265.287 278.226C262.342 252.467 257.925 213.828 252.082 177.765C246.386 142.99 233.415 119.807 221.474 105.639C190.689 69.5761 155.868 73.44 124.905 73.44C99.1024 73.44 78.1661 70.864 55.2852 88.8955C33.1172 105.639 21.464 139.126 29.9572 198.372C30.3989 202.236 31.0112 215.116 21.5504 215.116C15.5298 215.116 10.346 207.388 9.60981 200.948C7.13009 186.781 2.73623 155.87 0.728654 108.215C0.139693 103.063 0.046254 72.152 1.84356 50.2566C3.36975 33.5131 6.78673 25.7853 12.4894 15.4815C21.1907 1.31394 34.8047 0.0259138 40.8253 0.0259138C68.3478 0.0259138 144.035 0.0259138 190.479 0.0259138C224.022 0.0259138 292.828 0.0259138 292.828 0.0259138C292.828 0.0259138 360.774 0.0259138 394.317 0.0259138C440.761 0.0259138 516.448 0.0259138 543.971 0.0259138C549.991 0.0259138 563.9 1.31394 575.84 15.4815C584.759 25.7853 589.083 33.5131 594.437 50.2566C601.241 72.152 607.355 103.063 608.804 108.215C619.412 155.87 621.226 186.781 622.845 200.948Z"
                        fill="#335B6F"
                    />
                </svg>
            </div>
        </section>
        <section class="partners">
            <div class="container">
                <h5 class="title" data-aos="fade-right" data-aos-duration="1000" >Colaboradores</h5>
                <ListCardPersonInfo :data="data.collaborators"/>
            </div>
            <div class="figure">
                <svg
                    width="6260"
                    height="3122"
                    viewBox="0 0 6260 3122"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6241.63 1141.44C6267.29 906.647 6280.06 651.723 6167.77 422.28C6071.92 226.526 5667.28 213.816 5340.75 177.937C5208.55 163.403 5075.89 148.869 4942.43 138.105C4893.87 134.152 4843.48 130.443 4796.08 139.929C4746.6 149.842 4743.73 189.674 4784.92 205.181C4819.89 218.377 4868.79 223.181 4909.64 228.107C4968.09 236.681 5024.46 249.209 5079.11 263.135C5203.72 294.939 5321.08 334.467 5417.15 387.799C5592.95 477.922 5701.91 584.283 5744.13 707.001C5786.36 829.659 5791.54 1037.39 5770.94 1225.85C5755.52 1366.51 5669.81 1617.42 5536.46 1769.93C5403.11 1922.45 5211.77 2060.43 4962.33 2184C4712.89 2307.51 4406.39 2406.7 4042.93 2481.56C3679.47 2556.35 3262.62 2586.52 2792.28 2571.98C2406.5 2560.06 2038.09 2522.54 1687.06 2459.42C1336.02 2396.36 1034.23 2283.25 781.573 2120.21C633.152 2022.49 523.505 1909.74 452.631 1781.91C240.469 1399.35 452.401 538.248 978.893 313.913C1090.38 263.743 1212.34 227.316 1344.77 204.573C1477.2 181.829 1604.33 170.944 1726.18 171.917C1776.8 173.498 1887.94 177.207 1903.71 140.902C1925.8 89.6379 1792.22 83.9216 1728.48 78.8134C1449.93 48.7723 860.041 35.8801 580.687 7.90659C479.784 -2.1882 366.109 -16.0533 338.036 65.3739C315.945 129.348 293.394 195.208 256.922 261.857C109.651 531.133 41.6536 813.179 11.164 1092.49C-33.4774 1500.78 46.4858 2012.94 447.453 2369.54C874.078 2748.95 1587.76 3002.53 2399.71 3087.06C3209.35 3171.41 4107.24 3105.67 4794.93 2853.54C5451.32 2612.91 5869.43 2236.24 6064.79 1831.11C6157.18 1639.67 6220 1338.66 6241.63 1141.44Z"
                        fill="#33647E"
                        fill-opacity="0.1"
                    />
                </svg>
            </div>
        </section>
        <Footer />
    </div>
</template>
<script>
import Banner from "../components/General/Banner.vue"
import Footer from "../components/General/Footer.vue"

import CardMemberList from "../components/About/CardMemberList.vue"
import ListCardPersonInfo from "../components/About/ListCardPersonInfo.vue"
import { mapState, mapActions } from "vuex";
export default {
    inject: ['baseUrlStorage'],
    components: {
        Banner, Footer, CardMemberList, ListCardPersonInfo
    },
    computed: {
    ...mapState({
      data: (state) => state.dataAbout,
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(["getDataAdmin"]),
    getData() {
      var _this = this;
      this.getDataAdmin({
        url: "getNosotros",
        type: "POST",
        params: { ref: this.$route.params.type },
      }).then(
        (res) => {
          console.log(res.data);
          _this.data = res.data;
          this.$store.commit("SET_DATA_ABOUT", {
            data: res.data,
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
}
</script>
<style lang="css" scoped>
.misionvision {
    background-image: url(https://i.ibb.co/Y7JK3jM/Contact-Banner-Img.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    overflow: hidden;
    padding: 200px 0;
}
.misionvision .cortina {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(1, 55, 84, 0.97);
    z-index: 1;
}
.misionvision .content {
    position: relative;
    z-index: 2;
}
.misionvision .content .general {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    color: #ffffff;
    max-width: 800px;
    margin: auto;
    margin-bottom: 46px;
}
.misionvision .content .about {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    column-gap: 140px;
}
.misionvision .content .about .about-item .title {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: #ffffff;
    margin-bottom: 8px;
}
.misionvision .content .about .about-item .description {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    color: #ffffff;
    margin-bottom: 0;
}

@media (max-width: 992px) {
    .misionvision {
        padding: 40px 0;
    }
    .misionvision .content .general {
        font-size: 16px;
        line-height: 19px;
    }
    .misionvision .content .about {
        flex-direction: column;
    }
    .misionvision .content .about .about-item:nth-child(1) {
        margin-bottom: 30px;
    }
    .misionvision .content .about .about-item .title {
        font-size: 24px;
        line-height: 29px;
    }
    .misionvision .content .about .about-item .description {
        font-size: 16px;
        line-height: 19px;
    }
}

.members {
    padding: 62px 0;
    position: relative;
    overflow: hidden;
}
.members .title {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    color: #33647e;
    text-align: center;
    margin-bottom: 30px;
    position: relative;
    z-index: 2;
}
.members .list {
    max-width: 1000px;
    margin: auto;
    position: relative;
    z-index: 2;
}
.members .figure {
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: -800px;
}
@media (max-width: 768px) {
    .members .title {
        font-size: 32px;
        line-height: 38px;
    }
}
.consejo {
    background: linear-gradient(134.17deg, #eef0f5 4.98%, #e6e9ef 94.88%);
    padding: 140px 0;
    position: relative;
    overflow: hidden;
}
.consejo .container {
    position: relative;
    z-index: 2;
}
.consejo .title {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    text-align: center;
    color: #33647e;
    margin-bottom: 80px;
}
.consejo .figure-01 {
    position: absolute;
    z-index: 1;
    left: -150px;
    bottom: -20px;
}
.consejo .figure-02 {
    position: absolute;
    z-index: 1;
    right: -150px;
    bottom: -20px;
}
@media (max-width: 768px) {
    .consejo {
        padding: 40px 0;
    }
    .consejo .title {
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 40px;
    }
    .consejo .figure-02 {
        display: none;
    }
}
.partners {
    background: #ffffff;
    padding: 140px 0 120px;
    position: relative;
    overflow: hidden;
}
.partners .container {
    position: relative;
    z-index: 2;
}
.partners .title {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    text-align: center;
    color: #33647e;
    margin-bottom: 80px;
}
.partners .figure {
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: -800px;
}

@media (max-width: 768px) {
    .partners {
        padding: 40px 0;
    }
    .partners .title {
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 40px;
    }
}
</style>